import http from "../../core/http";

// Define action types
export const SYNC_READING = "SYNC_READING";
export const SET_PREVIOUS_COMICS = "SET_PREVIOUS_COMICS";
export const MARK_AS_READ = "MARK_AS_READ";
export const MARK_AS_UNREAD = "MARK_AS_UNREAD";
export const MARK_AS_SKIPPED = "MARK_AS_SKIPPED";
export const MARK_AS_READ_LATER = "MARK_AS_READ_LATER";
export const MARK_PREVIOUS_AS_READ = "MARK_PREVIOUS_AS_READ";
export const MARK_PREVIOUS_AS_SKIPPED = "MARK_PREVIOUS_AS_SKIPPED";
export const MARK_PREVIOUS_AS_READ_LATER = "MARK_PREVIOUS_AS_READ_LATER";
export const SET_ORDER_POSITION = "SET_ORDER_POSITION";
export const RESET_READING = "RESET_READING";

export const getReadingOrder = (readingId, data) => {
  return {
    type: SYNC_READING,
    payload: { readingId, data: data },
  };
};

export const setPreviousComics = (readingId, data) => {
  return {
    type: SET_PREVIOUS_COMICS,
    payload: { readingId, data: data },
  };
};

/**
 * Optimistic UI to mark as read
 * @param {*} comicId
 * @param {*} story
 * @param {*} readingId
 * @returns
 */
export const markAsRead = (comicId, story, readingId) => {
  return (dispatch) => {
    dispatch({ type: MARK_AS_READ, payload: { comicId, story, readingId } });
    return http
      .post("/v1/readings/exp/mark-as-read", {
        comicId,
        readingId,
        skipped: 0,
        readLater: 0,
        story,
      })
      .catch((error) => {
        dispatch({
          type: MARK_AS_UNREAD,
          payload: { comicId, story, readingId },
        });
      });
  };
};

/**
 * Optimistic UI to mark as unread
 * @param {*} comicId
 * @param {*} story
 * @param {*} readingId
 * @returns
 */
export const markAsUnRead = (comicId, story, readingId, skipped) => {
  return (dispatch) => {
    dispatch({ type: MARK_AS_UNREAD, payload: { comicId, story, readingId } });
    return http
      .post("/v1/readings/mark-as-unread", {
        comicId,
        readingId,
        skipped: !!skipped,
        story,
      })
      .catch(() => {
        dispatch({
          type: skipped ? MARK_AS_SKIPPED : MARK_AS_READ,
          payload: { comicId, story, readingId },
        });
      });
  };
};

/**
 * Optimistic UI to mark as skipped
 * @param {*} comicId
 * @param {*} story
 * @param {*} readingId
 * @returns
 */
export const markAsSkipped = (comicId, story, readingId) => {
  return (dispatch) => {
    dispatch({
      type: MARK_AS_SKIPPED,
      payload: { comicId, story, readingId },
    });
    return http
      .post("/v1/readings/exp/mark-as-read", {
        comicId,
        readingId,
        skipped: 1,
        readLater: 0,
        story,
      })
      .catch(() => {
        dispatch({
          type: MARK_AS_UNREAD,
          payload: { comicId, story, readingId },
        });
      });
  };
};

/**
 * Optimistic UI to mark as read later
 * @param {*} comicId
 * @param {*} story
 * @param {*} readingId
 * @returns
 */
export const markAsReadLater = (comicId, story, readingId) => {
  return (dispatch) => {
    dispatch({
      type: MARK_AS_READ_LATER,
      payload: { comicId, story, readingId },
    });
    return http
      .post("/v1/readings/exp/mark-as-read", {
        comicId,
        readingId,
        skipped: 0,
        readLater: 1,
        story,
      })
      .catch(() => {
        dispatch({
          type: MARK_AS_UNREAD,
          payload: { comicId, story, readingId },
        });
      });
  };
};

export const setOrderPosition = (readingId, orderPosition) => ({
  type: SET_ORDER_POSITION,
  payload: { readingId, orderPosition },
});

export const markPreviousAsRead = (readingId, order) => ({
  type: MARK_PREVIOUS_AS_READ,
  payload: { readingId, order },
});

export const markPreviousAsReadLater = (readingId, order) => ({
  type: MARK_PREVIOUS_AS_READ_LATER,
  payload: { readingId, order },
});

export const markPreviousAsSkipped = (readingId, order) => ({
  type: MARK_PREVIOUS_AS_SKIPPED,
  payload: { readingId, order },
});

export const resetReading = (readingId) => ({
  type: RESET_READING,
  payload: { readingId },
});
